import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Button, ButtonProps } from '@zapier/marketing-ui';

export type SocialAuthButtonProps = Omit<ButtonProps, 'icon'> & {
  icon: ReactNode;
};

const styles = {
  root: css({
    position: 'relative',
  }),

  icon: css({
    display: 'flex',
    width: '20px',
    position: 'absolute',
    left: '16px',
  }),
};

/**
 * Wrapper to style SSO buttons (i.e. facebook)
 */
export function SocialAuthButton({
  children,
  icon,
  ...props
}: SocialAuthButtonProps) {
  return (
    <Button {...props} variant="secondary" fullWidth={true} css={styles.root}>
      <div css={styles.icon}>{icon}</div>
      {children}
    </Button>
  );
}
